import script from "./PorfolioIndexesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PorfolioIndexesCard.vue?vue&type=script&setup=true&lang=js"

import "./PorfolioIndexesCard.vue?vue&type=style&index=0&id=62951a85&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62951a85"]])

export default __exports__